
<div class="c-header-search__block">
  <div class="c-header-search__block-header t-xs-hide t-lg-block">
    <span
      v-if="isDesktop"
      class="c-header-search__block-title "
    >
      {{ selectedContextLongLabel }}
    </span>
  </div>

  <div class="c-header-search__context-selector">
    <template v-for="context in contextOptionsFiltered">
      <button
        :key="'context-button-' + context.value"
        type="button"
        class="c-header-search__context-button"
        :class="{
          'is-active': context.value === selectedContext
        }"
        @click="chooseContext(context.value)"
      >
        {{ context.label_short }}
      </button>
    </template>
  </div>
</div>
